/**
 * =============================================================================
 * Project: lajt-online.pl
 * Created Date: 2017-10-09, 13:08:58
 * Author: Sebastian Drzewicki <sebastian.drzewicki@telestrada.pl>
 * =============================================================================
 * Last Modified: 2018-02-22, 12:14:51
 * Modified By: Sebastian Drzewicki
 * =============================================================================
 * Copyright (c) 2017 Telestrada
 * =============================================================================
 */
import { mapActions, mapGetters } from 'vuex';
import store from '@/store';

// COMPONENT ///////////////////////////////////////////////////////////////////
export default {
  name: 'OfflineIndicator',
  store,
  data() {
    return {
      online: true,
    };
  },
  computed: {
    ...mapGetters(['isOffline']),
  },
  methods: {
    ...mapActions(['toggleOfflineStatus']),
  },
  mounted() {
    if (navigator) {
      if (!navigator.onLine) this.toggleOfflineStatus();
    }
    window.addEventListener('online', () => this.toggleOfflineStatus());
    window.addEventListener('offline', () => this.toggleOfflineStatus());
  },
};



// WEBPACK FOOTER //
// ./src/components/Common/OfflineIndicator/component.js